import ConditionalRendering from "pages/ConditionalRendering";
import React from "react";

const index = () => {
  return <ConditionalRendering />;
};

export default index;
